import { AttributeType } from '@containers/ProductListing/model';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

type Return = 'noVoucherDiscount' | 'priceBelowMinCondition' | 'default';

export const usePriceLabelState = ({
  attributes,
}: {
  attributes?: AttributeType;
} = {}): Return => {
  const voucherDiscount = useResolvedVoucherDiscount(
    attributes ? { attributes } : undefined
  );

  if (!voucherDiscount) {
    return 'noVoucherDiscount';
  }

  if (
    isConditionalDiscount(voucherDiscount) &&
    voucherDiscount.discountType === 'Absolute'
  ) {
    return 'priceBelowMinCondition';
  }

  const isPriceBelowMinCondition =
    isConditionalDiscount(voucherDiscount) &&
    voucherDiscount.discountConditions.some(
      ({ productMeetsCondition }) => !productMeetsCondition
    );

  if (isPriceBelowMinCondition) {
    return 'priceBelowMinCondition';
  }

  return 'default';
};
